import React, { PureComponent } from 'react';
import _ from 'lodash';
import Slider from 'react-slick';

export default class MySlider extends PureComponent {
  render() {
    const { sliderRef, items, uiRenderer, settings, buttonNext, buttonPrev, arrows = false } = this.props;
    const options = {
      dots: true,
      infinite: true,
      arrows: arrows,
      nextArrow: buttonNext,
      prevArrow: buttonPrev,
      ...settings
    };
    return (
      <Slider ref={sliderRef} {...options}>
        {_.map(items, (item, index) => {
          return <div key={index}>{uiRenderer(item, index)}</div>;
        })}
      </Slider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider.js